import React from 'react';

const coverFrameStyle: React.CSSProperties = {
  width: 'max(100cqw, 177.777778cqh)',
  height: 'max(100cqh, 56.25cqw)',
};

export const youtubeCoverContainerStyle: React.CSSProperties = {
  containerType: 'size',
};

type YouTubeCoverFrameProps = React.IframeHTMLAttributes<HTMLIFrameElement>;

const YouTubeCoverFrame = React.forwardRef<HTMLIFrameElement, YouTubeCoverFrameProps>(
  ({ className = '', style, ...props }, ref) => (
    <iframe
      ref={ref}
      className={`absolute left-1/2 top-1/2 h-full w-full max-w-none -translate-x-1/2 -translate-y-1/2 ${className}`}
      style={{ ...coverFrameStyle, ...style }}
      {...props}
    />
  ),
);

YouTubeCoverFrame.displayName = 'YouTubeCoverFrame';

export default YouTubeCoverFrame;
